import {
	LINKEDIN_INVITE_NOTE_MAX_LENGTH,
	LINKEDIN_INVITE_NOTE_PREMIUM_MAX_LENGTH,
} from "@signalist/shared-types";

/**
 * Re-exported from `@signalist/shared-types` so the editor's cap and the API's
 * authoritative send-time check cannot drift apart (PREC-3970).
 */
export const INVITE_NOTE_LIMIT = LINKEDIN_INVITE_NOTE_MAX_LENGTH;
export const INVITE_NOTE_PREMIUM_LIMIT = LINKEDIN_INVITE_NOTE_PREMIUM_MAX_LENGTH;
